module.exports = __webpack_public_path__ + "static/img/CF.b0592f69.png";